module.exports = __webpack_public_path__ + "static/media/svg-2.126c09c6.svg";